import React, { Component } from 'react';
import '../css/app.css';
import Header from '../component/header';
import Footer from '../component/footer';

class Nomatch extends Component {
  constructor(props) {
    super(props);
}

  render() {
    return (
      <div className="nomatch-frame">
         <Header context={(this.props.context !== undefined) ? this.props.context: "" } />
         <div className="nomatch-text">
              <section>
                    <div className="secondary_banner_wrap">
                        <div>
                            <img src="/static/images/img_food_1.jpg" alt="" />
                        </div>
                    </div>
              </section>
              <section>
                  <div className="nomatch-wp">
                    <div className="nomatch-title"> 404 !</div>
                    <div className="nomatch-desc"> 抱歉，找不到您查詢的網頁！</div>
                  </div>
              </section>
              
         </div>
         <Footer context={(this.props.context !== undefined) ? this.props.context: "" } />
      </div>
    );
  }
}

export default Nomatch;



// WEBPACK FOOTER //
// ./src/pages/nomatch.js